import { jsx as u } from "react/jsx-runtime";
import { useMemo as d, isValidElement as y } from "react";
const P = ({
  schema: t,
  props: e,
  children: r,
  ErrorComponent: o
}) => {
  const n = d(() => t.safeParse(e), [e]);
  if (n.success === !1) {
    if (console.error({
      passedProps: e,
      zodError: n.error
    }), o)
      return /* @__PURE__ */ u(o, { result: n });
  } else if (n.success === !0)
    return r(n);
  return null;
};
function p(t, e = "", r = {}, o = ".", n) {
  for (const i in t)
    if (t.hasOwnProperty(i)) {
      const s = t[i], l = e ? `${e}${o}${i}` : i;
      n && n(s) ? r[l] = s : typeof s == "object" && s !== null && !Array.isArray(s) ? p(s, l, r, o, n) : r[l] = s;
    }
  return r;
}
function g(t, e = ".", r) {
  const o = {};
  for (const [n, i] of Object.entries(t)) {
    if (r && r(n)) {
      o[n] = i;
      continue;
    }
    const s = n.split(e);
    let l = o;
    for (let c = 0; c < s.length; c++) {
      const m = c === s.length - 1, f = s[c];
      f !== void 0 && (m ? l[f] = i : ((typeof l[f] != "object" || l[f] === null) && (l[f] = {}), l = l[f]));
    }
  }
  return o;
}
function h(t = ".", e) {
  return {
    flatten: (r) => p(r, "", {}, t, e == null ? void 0 : e.skipFlatten),
    unflatten: (r) => g(r, t, e == null ? void 0 : e.skipUnflatten),
    delimiter: () => t
  };
}
function j(t) {
  return t instanceof Date && !isNaN(t.getTime());
}
const b = (t) => y(t) || j(t), a = h("///", {
  skipFlatten: b
});
function N(t, e) {
  const r = a.flatten(t), o = a.flatten(e), n = { ...r, ...o };
  return a.unflatten(n);
}
function F(t, e, r) {
  const o = (n) => {
    const i = "defaultProps" in t ? t.schema : t, s = d(() => "defaultProps" in t ? N(t.defaultProps, n) : n, [n]);
    return /* @__PURE__ */ u(
      P,
      {
        schema: i,
        props: s,
        ErrorComponent: r,
        children: ({ data: l }) => /* @__PURE__ */ u(e, { ...l })
      }
    );
  };
  return o.displayName = `Zod(${e.displayName})`, o;
}
export {
  P as ZodPropGuard,
  N as propMerger,
  F as withZod
};
